import { render, staticRenderFns } from "./DetectSSH.vue?vue&type=template&id=21507804&"
import script from "./DetectSSH.vue?vue&type=script&lang=js&"
export * from "./DetectSSH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports